import { APP_ROUTES } from '@/routes';
import { useRouter } from 'next/navigation';

export const useHome = () => {
	const router = useRouter();

	const handleNavigateCTA = (url: string) => router.push(url);

	const handleNavigateToProductDetail = (collectionSlug: string, productSlug: string) => {
		const url = APP_ROUTES.SHOP.PRODUCT_DETAILS
			.replace(':collectionSlug', collectionSlug)
			.replace(':productSlug', productSlug);
		router.push(url);
	};

	return {
		handleNavigateCTA,
		handleNavigateToProductDetail,
	};
};